let user = sessionStorage.getItem('userInfo')
  ? JSON.parse(sessionStorage.getItem('userInfo'))
  : {};
let activeMenu = sessionStorage.getItem("activeMenu")?sessionStorage.getItem("activeMenu"):'index';
export default {
  userInfo: user,
  activeMenu : activeMenu
};



// WEBPACK FOOTER //
// ./src/store/state.js